import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Text } from '../../BuildingBlocks/Text';
import { AvatarImage } from '../../BuildingBlocks/AvatarImage';
import { Grid } from '../../Utility/Grid';
import { SVGIcon } from '../../BuildingBlocks/SVGIcon';
import { colors, mixins, media, fonts } from '../../css';

const pulseAnim = css`
  ${keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`}
`;

export const PulseWrapper = styled.div`
  animation: ${pulseAnim} 125ms ease-in-out;

  tr {
    background-color: ${colors.colorWhite};
  }
`;

const spreadCol = ({ children, ...rest }) => (
  <Grid.Col {...rest}>
    <Text.CopyMini noMargins>{children}</Text.CopyMini>
  </Grid.Col>
);

export const ColHeader = styled(spreadCol)`
  padding: ${mixins.pxToRem(15)} 0;
`;

const spreadContainer = ({ children, ...rest }) => (
  <div {...rest}>
    <div style={{}}>{children}</div>
  </div>
);
export const OverflowContainer = styled(spreadContainer)`
  overflow-x: auto;
`;

// new

export const StyledImageDefault = styled.div`
  background-color: ${colors.colorGrey04};
  display: block;
  width: auto;
  height: 100%;
  padding-top: calc(4 / 6 * 100%);
  overflow: hidden;
`;

export const StyledImageContainer = styled.div`
  display: block;
  height: 100%;
  width: auto;
  position: relative;
`;

export const StyledSVGContainer = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
export const StyledSVGPlacement = styled(SVGIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

export const RowContainer = styled(Grid.Row)`
  height: ${mixins.pxToRem(88)};
  padding: ${mixins.pxToRem(17)} 0;
  max-width: 100%;

  &:hover {
    background-color: ${colors.colorGrey05};
    cursor: pointer;
  }
`;

// CARDS

export const CardContainer = styled.div`
  background: ${colors.colorWhite};
  margin: ${mixins.pxToRem(10)};
  ${media.greaterThan('md')`margin: ${mixins.pxToRem(36)} 0;`};
  border-radius: 2px;
  box-shadow: 0px 0px 24px 2px rgba(0, 0, 0, 0.024);
  position: relative;
`;

export const LabelWrapper = styled.span`
  position: absolute;
  padding: 5px;
  background-color: ${colors.colorBlue};
  ${({ theme }) => `color: ${theme.lighterText}`};
`;

export const CardTitle = styled(Text.HeadingFourth)`
  width: 100%;
  ${media.greaterThan('md')`width: 90%;`};
  margin-bottom: 1rem;
`;

export const UpperDetailsContainer = styled.div`
  padding: ${mixins.pxToRem(20)} ${mixins.pxToRem(20)} 0 ${mixins.pxToRem(20)};
  padding-top: ${({ hasLabel }) => (hasLabel ? mixins.pxToRem(40) : mixins.pxToRem(20))};
`;

export const CardDetailsFlex = styled.div`
  display: flex;
  div {
    flex-grow: 1;
  }
`;

export const CardDetailsHeader = styled(Text.CopyMini)`
  margin: 0;
`;

export const CardDetails = styled(Text.CopyParagraph)`
  margin: 0;
  word-wrap: break-word;
`;

export const CardImpDetails = styled(Text.HeadingFifth)``;

export const ViewDetails = styled.div`
  padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(20)};
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
`;

export const ViewDetailsLink = styled(Text.HeadingSixth)`
  color: ${colors.colorBlue};
  text-transform: uppercase;
  margin: 0;
`;

export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfo = styled.div`
  flex-grow: 1;
  height: 100%;
  padding-left: 5px;
`;

export const ProfilePic = styled.div`
  width: ${mixins.pxToRem(60)};
  height: ${mixins.pxToRem(60)};
  margin: ${mixins.pxToRem(10)} auto;
  ${media.lessThan('lg')`margin-left: 0`};
  flex-grow: 0;
`;

export const AutoAvatar = styled(AvatarImage)`
  width: 60px;
  height: 60px;
`;

export const StatusImage = styled.div`
  background-color: ${colors.colorGrey04};
  height: ${({ isCard }) => (isCard ? 'auto' : '90px')};
  width: ${({ isCard }) => (isCard ? '100%' : mixins.pxToRem(135))};
  position: relative;
  cursor: default;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;

export const Status = styled.div`
  ${({ theme }) => `background-color: ${theme.midTheme}`};
  background-color: ${({ status }) => {
    if (status === 'Rejected') {
      return colors.colorRed;
    }
    if (status === 'Archived') {
      return colors.colorOrange;
    }
    if (status === 'Pending' || status === 'Draft' || status === 'Incomplete') {
      return colors.colorBlue03;
    }
    if (status === 'Reconciled') {
      return colors.colorGrey03;
    }
    // Published, Approved
    return colors.colorBlue02;
  }};
  position: absolute;
  text-align: center;
  padding: 2px 5px;
  text-transform: uppercase;
  color: ${colors.colorWhite};
  font-family: ${fonts.fontRegular};
  font-size: ${({ isCard }) => (isCard ? mixins.pxToRem(16) : mixins.pxToRem(12))};
  z-index: 5;
`;

export const AutoApproveCard = styled.div`
  padding-left: 30px;
`;
